import { WarningDialog } from '@strata/react-dialog';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { resetForm } from 'store/referralForm/referralFormSlice';

export const CancelReferralDialog = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();

    return (
        <WarningDialog
            dialogTitle="Cancel Referral"
            isOpen={isOpen}
            onPrimaryButtonClick={() => {
                dispatch(resetForm());
                onClose();
            }}
            onSecondaryButtonClick={() => onClose()}
            dialogContent={<p>Are you sure you want to cancel this referral?</p>}
        />
    );
};

CancelReferralDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
